import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import FlexOne from './FlexOne';

const styles = {
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255,255,255,.5)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center"
  },
  message: {
    marginLeft: 5
  }
}

const AyncLoading = ({message, classes}) => (
  <div className={classes.root}>
    <FlexOne/><CircularProgress className={classes.progress} /><span className={classes.message}>{message}</span><FlexOne/>
  </div>
)

export default withStyles(styles)(AyncLoading);